import React from 'react'
// Styles
import * as styles from './ProfileContent.module.css'

const ProfileContent: React.FC = ({ children }) => {
    return <section className={styles.profile_content}>{children}</section>
}

export default ProfileContent
